package com.devi3east.bashbuddy.cart.responses

import com.devi3east.bashbuddy.purchase.domain.models.OrgSubPurchase
import com.devi3east.bashbuddy.purchase.domain.models.PurchaseStatus
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class TicketPurchaseResponse(
    val _id: String,
    val userId: String,
    val createdAtInstant: Instant,
    val status: PurchaseStatus,
    val subPurchases: List<OrgSubPurchase>
)